import { Permission } from '_metronic/helpers'
import { useAuth } from '../../../../auth'

/**
 * Grupos que recebem a permissão `Unidade:update` no seed do backend
 * (`lauduzone-backend/src/main/resources/permission.json`). É essa permissão que protege a
 * gravação da unidade — incluindo o campo `codigoIbge` (município IBGE usado pela Ficha de
 * Atendimento Individual do e-SUS APS).
 *
 * `Unidade:read` é mais ampla (`MEDICO` e `EMPLOYEE` também leem), então há usuários que abrem o
 * cadastro da unidade sem poder alterá-lo.
 *
 * LIMITAÇÃO CONHECIDA (arquitetura, a mesma descrita em `_esusPermissao.ts`): o frontend não
 * consegue checar a permissão pelo nome. `/usuarios/me` devolve `UsuarioDtoVinculo`, cujo `grupo`
 * vem de `new GrupoDto(usuario.getGrupo())` — construtor que NÃO preenche a lista `perfis`. A única
 * informação de autorização disponível no cliente é o NOME DO GRUPO (`currentUser.grupo.nome`),
 * que é o que o resto do app já usa para gatear UI (ver `Permission` em
 * `_metronic/helpers/enums.ts`). Se um gestor alterar em runtime quais grupos têm
 * `Unidade:update`, esta lista fica dessincronizada; o backend segue como autoridade real e
 * devolve 403.
 */
export const GRUPOS_UNIDADE_UPDATE: Permission[] = [
  Permission.SuperAdmin,
  Permission.SuperMedico,
  Permission.Admin,
]

export const MSG_SEM_PERMISSAO_UNIDADE_UPDATE =
  'Você não tem permissão para alterar os dados da unidade. ' +
  'Solicite ao administrador da instituição a permissão "Unidade:update".'

/** Indica se o usuário autenticado pode gravar alterações no cadastro da unidade. */
export const usePermissaoUnidadeUpdate = (): boolean => {
  const { currentUser } = useAuth()
  return GRUPOS_UNIDADE_UPDATE.includes(currentUser?.grupo?.nome as Permission)
}
